import { auth } from '../firebaseConfig';

// Asks the server whether people are already in Resi as someone else's private contact. The answer is
// only 'none' | 'yours' | 'other' (exists, owned by another team member); no details are revealed.
// If the check can't run (offline, function not deployed), every result is 'none' so saving still works.
const call = async (body) => {
  const idToken = await auth.currentUser.getIdToken();
  const res = await fetch('/api/contact-match', { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` }, body: JSON.stringify(body) });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};
export const checkPrivateMatches = async (people) => {
  try { return (await call({ action: 'check', people: people.map((p) => ({ phone: p.phone || '', email: p.email || '' })) })).results || []; } catch (e) { console.warn('Private duplicate check unavailable', e); return people.map(() => ({ status: 'none' })); }
};
export const requestShareFromOwner = async (person) => {
  try { return await call({ action: 'request', person: { phone: person.phone || '', email: person.email || '' } }); } catch (e) { return { requested: false, error: e.message }; }
};
